// extracted by mini-css-extract-plugin
export var addButton = "_jg-0";
export var border = "_jg-8";
export var check = "_jg-h";
export var danger = "_jg-6";
export var dropdownContainer = "_jg-1";
export var editModalBody = "_jg-j";
export var footerContainer = "_jg-i";
export var fullWidth = "_jg-a";
export var hide = "_jg-9";
export var icon = "_jg-3";
export var input = "_jg-7";
export var inputFlex = "_jg-b";
export var inputWrapper = "_jg-c";
export var manualFocus = "_jg-5";
export var optionButton = "_jg-4";
export var pillWrapper = "_jg-e";
export var pointer = "_jg-2";
export var showOverflow = "_jg-f";
export var tagsFlex = "_jg-d";
export var xButton = "_jg-g";